export default "__VITE_ASSET__BbQ8LsXX__"